(function() {
    // Track which tiers have been shown as popups in this session
    const shownTiers = new Set(JSON.parse(sessionStorage.getItem('shownTierPopups') || '[]'));

    // Previous cart value to detect tier crossings
    let previousCartValue = 0;

    // Active popup element
    let activePopup = null;

    function saveShownTiers() {
        sessionStorage.setItem('shownTierPopups', JSON.stringify([...shownTiers]));
    }

    function getTierData(freeShippingBar) {
        try {
        const tiersAttr = freeShippingBar.getAttribute('data-tiers');
        if (!tiersAttr) return [];
        return JSON.parse(tiersAttr);
        } catch (e) {
        console.error('Error parsing tier data:', e);
        return [];
        }
    }

    function closeActivePopup() {
        if (activePopup) {
        activePopup.classList.remove('tier-popup--visible');
        setTimeout(() => {
            if (activePopup && activePopup.parentNode) {
            activePopup.parentNode.removeChild(activePopup);
            }
            activePopup = null;
        }, 300);
        }
    }

    async function fetchCollectionProducts(collectionHandle) {
        if (!collectionHandle) return [];
        try {
        const response = await fetch(`/collections/${collectionHandle}/products.json?limit=6`);
        if (!response.ok) return [];
        const data = await response.json();
        return data.products || [];
        } catch (e) {
        console.error('Error fetching collection products:', e);
        return [];
        }
    }

    function renderProducts(products, container) {
        if (!products.length) {
        container.innerHTML = '<p class="tier-popup__no-products">No gift products available</p>';
        return;
        }

        const html = products.map(product => {
        const image = product.images?.[0]?.src || '';
        const imageSmall = image ? image.replace(/\.([^.]+)$/, '_100x100.$1') : '';
        return `
            <a href="/products/${product.handle}" class="tier-popup__product-item">
            ${imageSmall ? `<img class="tier-popup__product-image" src="${imageSmall}" alt="${product.title}" loading="lazy">` : ''}
            <span class="tier-popup__product-title">${product.title}</span>
            </a>
        `;
        }).join('');

        container.innerHTML = html;
    }

    async function showTierPopup(tier, freeShippingBar) {
        // Close any existing popup
        closeActivePopup();

        const template = document.getElementById('tier-popup-template');
        if (!template) return;

        const popup = template.content.cloneNode(true).firstElementChild;
        if (!popup) return;

        // Populate popup data
        const labelEl = popup.querySelector('[data-tier-label]');
        if (labelEl) labelEl.textContent = tier.label;

        // Close button handler
        const closeBtn = popup.querySelector('.tier-popup__close');
        if (closeBtn) {
        closeBtn.addEventListener('click', closeActivePopup);
        }

        // Position popup relative to the free shipping bar
        const progressWrapper = freeShippingBar.querySelector('.free-shipping-bar__progress-wrapper');
        if (progressWrapper) {
        progressWrapper.appendChild(popup);
        activePopup = popup;

        // Trigger animation
        requestAnimationFrame(() => {
            popup.classList.add('tier-popup--visible');
        });

        // Fetch and render products from collection
        const productsContainer = popup.querySelector('[data-tier-products]');
        if (tier.collectionHandle && productsContainer) {
            const products = await fetchCollectionProducts(tier.collectionHandle);
            renderProducts(products, productsContainer);
        } else if (productsContainer) {
            productsContainer.innerHTML = '';
        }

        // Auto-close after 8 seconds (longer for multiple products)
        setTimeout(closeActivePopup, 8000);
        }

        // Mark tier as shown
        shownTiers.add(tier.tier);
        saveShownTiers();
    }

    function updateTierDots(freeShippingBar, currentValue) {
        const tiers = getTierData(freeShippingBar);
        const tierDots = freeShippingBar.querySelectorAll('.free-shipping-bar__tier-dot');

        tierDots.forEach(dot => {
        const tierNum = parseInt(dot.dataset.tier);
        const threshold = parseInt(dot.dataset.threshold);
        const wasReached = dot.classList.contains('free-shipping-bar__tier-dot--reached');
        const isReached = currentValue >= threshold;

        if (isReached && !wasReached) {
            dot.classList.add('free-shipping-bar__tier-dot--reached');
            dot.classList.add('free-shipping-bar__tier-dot--just-reached');
            setTimeout(() => {
            dot.classList.remove('free-shipping-bar__tier-dot--just-reached');
            }, 500);

            // Show popup for this tier if not shown before
            const showPopup = freeShippingBar.getAttribute('data-show-tier-popup') === 'true';
            if (showPopup && !shownTiers.has(tierNum)) {
            const tierData = tiers.find(t => t.tier === tierNum);
            if (tierData) {
                showTierPopup(tierData, freeShippingBar);
            }
            }
        } else if (!isReached && wasReached) {
            dot.classList.remove('free-shipping-bar__tier-dot--reached');
            // Remove from shown tiers so it can be shown again if crossed again
            shownTiers.delete(tierNum);
            saveShownTiers();
        }
        });
    }

    function onCartChange(event) {
        const freeShippingBars = document.querySelectorAll('free-shipping-bar[data-tiers-enabled="true"]');

        freeShippingBars.forEach(bar => {
        const currentValue = parseFloat(bar.getAttribute('total-price')) || 0;
        updateTierDots(bar, currentValue);
        previousCartValue = currentValue;
        });
    }

    function init() {
        // Listen for cart changes
        document.addEventListener('cart:change', onCartChange);
        document.addEventListener('cart:refresh', onCartChange);

        // Initial check on page load
        const freeShippingBars = document.querySelectorAll('free-shipping-bar[data-tiers-enabled="true"]');
        freeShippingBars.forEach(bar => {
        const currentValue = parseFloat(bar.getAttribute('total-price')) || 0;
        previousCartValue = currentValue;
        // Don't show popup on initial load, just update dots
        const tierDots = bar.querySelectorAll('.free-shipping-bar__tier-dot');
        tierDots.forEach(dot => {
            const threshold = parseInt(dot.dataset.threshold);
            if (currentValue >= threshold) {
            dot.classList.add('free-shipping-bar__tier-dot--reached');
            }
        });
        });

        // Close popup when clicking outside
        document.addEventListener('click', (e) => {
        if (activePopup && !activePopup.contains(e.target)) {
            closeActivePopup();
        }
        });

        // Watch for attribute changes on free-shipping-bar elements
        const observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'total-price') {
            const bar = mutation.target;
            if (bar.hasAttribute('data-tiers-enabled')) {
                const currentValue = parseFloat(bar.getAttribute('total-price')) || 0;
                updateTierDots(bar, currentValue);
                previousCartValue = currentValue;
            }
            }
        });
        });

        document.querySelectorAll('free-shipping-bar[data-tiers-enabled="true"]').forEach(bar => {
        observer.observe(bar, { attributes: true });
        });

        // Also watch for dynamically added free-shipping-bar elements
        const bodyObserver = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) {
                const bars = node.matches?.('free-shipping-bar[data-tiers-enabled="true"]')
                ? [node]
                : node.querySelectorAll?.('free-shipping-bar[data-tiers-enabled="true"]') || [];

                bars.forEach(bar => {
                observer.observe(bar, { attributes: true });
                const currentValue = parseFloat(bar.getAttribute('total-price')) || 0;
                const tierDots = bar.querySelectorAll('.free-shipping-bar__tier-dot');
                tierDots.forEach(dot => {
                    const threshold = parseInt(dot.dataset.threshold);
                    if (currentValue >= threshold) {
                    dot.classList.add('free-shipping-bar__tier-dot--reached');
                    }
                });
                });
            }
            });
        });
        });

        bodyObserver.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    })();